import React from 'react'
import { Outlet } from 'react-router-dom'

import { MyStackedModalSlider } from '@interstellar-component'
import WorkforceHeader from './components/WorkforceHeader'
import WorkforceTable from './components/WorkforceTable'
import NewEmployeeSlider from './Sliders/NewEmployeeSlider'
import ImportWorkforceSlider from './Sliders/ImportWorkforceSlider'
import CreditCompositionSlider from './Sliders/CreditCompositionSlider'
import { useWorkforce } from './Context'

const SLIDER_COMPONENTS = {
  'new-employee': NewEmployeeSlider,
  'import-workforce': ImportWorkforceSlider,
  'credit-composition': CreditCompositionSlider,
}

function Workforce() {
  const { sliderStack, popSlider } = useWorkforce()

  return (
    <div className="flex h-full w-full flex-col bg-gray-50/50">
      {/* Stacked sliders (new-employee, import, credit-composition) */}
      {sliderStack.map((slider, index) => {
        const Component = SLIDER_COMPONENTS[slider.current]
        if (!Component) return null

        return (
          <MyStackedModalSlider
            key={`${slider.current}-${index}`}
            open
            offset={index * 420}
            zIndex={1000 + index * 10}
            element={<Component />}
            onClose={popSlider}
            scrim={index === 0}
          />
        )
      })}

      <div className="flex w-full flex-1 min-h-0 flex-col">
        <WorkforceHeader />
        <WorkforceTable />
        <Outlet />
      </div>
    </div>
  )
}

export default Workforce
